export default __webpack_public_path__ + "static/media/about-me.d6f53615.png";